import React from "react";
import { useDownloadLaudoPage } from "./useDownloadLaudoPage";

export const DownloadLaudo = () => {
  const { isPending, isError } = useDownloadLaudoPage();

  if (isError) return <p>Erro ao baixar o laudo.</p>;
  if (isPending) return <p>Baixando laudo...</p>;
  return <p>Download do laudo concluído.</p>;
};
